import { useTranslations } from 'next-intl';
import { useTracks } from '../utils/use-context';
import { isTimelineEmpty } from '../utils/is-timeline-empty';

/**
 * 타임라인에 클립이 없을 때 표시하는 안내 UI.
 * TimelineContainer 내부, Timeline 위에 오버레이로 표시.
 */
export function EmptyTimelinePlaceholder() {
  const t = useTranslations();
  const { tracks } = useTracks();

  if (!isTimelineEmpty(tracks)) {
    return null;
  }

  return (
    <div className="pointer-events-none absolute inset-0 z-10 flex items-center justify-center">
      <div className="flex flex-col items-center gap-xs text-center">
        <span className="text-sys-cont-neutral-tertiary text-title-small">
          {t('Editor.empty-timeline.title')}
        </span>
        <span className="text-body-small text-sys-cont-neutral-lightest">
          {t('Editor.empty-timeline.description')}
        </span>
      </div>
    </div>
  );
}
